<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Miscellaneous Items &nbsp;
          <add-button
            link="/planned-maintenance/miscellaneous-items/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">Miscellaneous Items</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportmiscellaneous_items.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="miscellaneous_items_excel"
                    :fields="excel_fields"
                    worksheet="Miscellaneous Items"
                    name="Miscellaneous Item.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Vessel</th>
                    <th>Item</th>
                    <th>Partner Number</th>
                    <th>Draw Number</th>
                    <th>Make</th>
                    <th>Model Number</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="miscellaneous_items.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(miscellaneous_item, at) in miscellaneous_items"
                    :key="`miscellaneous_item${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ miscellaneous_item.vessel.name }}</td>
                    <td>{{ miscellaneous_item.item }}</td>
                    <td>{{ miscellaneous_item.partner_no }}</td>
                    <td>{{ miscellaneous_item.drawn_no }}</td>
                    <td>{{ miscellaneous_item.make }}</td>
                    <td>{{ miscellaneous_item.model_no }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/planned-maintenance/miscellaneous-items/${miscellaneous_item.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(miscellaneous_item.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "miscellaneous_item",
  data() {
    return {
      miscellaneous_items: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      miscellaneous_items_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Vessel: "vessel",
        Item: "item",
        "Partner Number": "partner_no",
        "Draw Number": "drawn_no",
        Make: "make",
        "Model Number": "model_no",
        Measure: "measure",
      },
      Exportmiscellaneous_items: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let miscellaneous_items = await axios.get(
        `/miscellaneous_items?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.miscellaneous_items = miscellaneous_items.data.data;
      this.count = miscellaneous_items.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let miscellaneous_items = await axios.get(
        `/miscellaneous_items?search=${this.searchData}`
      );
      this.miscellaneous_items = miscellaneous_items.data.data;
      this.count = miscellaneous_items.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Miscellaneous Item Data";
      this.miscellaneous_items_excel = [];
      let Exportmiscellaneous_items = [];
      Exportmiscellaneous_items = await axios.get(`/miscellaneous_items`);
      this.Exportmiscellaneous_items = Exportmiscellaneous_items.data.data;
      let sr_no = 1;
      this.Exportmiscellaneous_items.forEach((miscellaneous_item) => {
        this.miscellaneous_items_excel.push({
          sr_no: sr_no,
          vessel: miscellaneous_item.vessel.name
            ? miscellaneous_item.vessel.name
            : "",
          item: miscellaneous_item.item ? miscellaneous_item.item : "",
          partner_no: miscellaneous_item.partner_no
            ? miscellaneous_item.partner_no
            : "",
          drawn_no: miscellaneous_item.drawn_no
            ? miscellaneous_item.drawn_no
            : "",
          make: miscellaneous_item.make ? miscellaneous_item.make : "",
          model_no: miscellaneous_item.model_no
            ? miscellaneous_item.model_no
            : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=miscellaneous_items`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
